import { render, staticRenderFns } from "./roomType.vue?vue&type=template&id=87d0e790"
import script from "./roomType.vue?vue&type=script&lang=js"
export * from "./roomType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports